import { createMuiTheme } from '@material-ui/core/styles/index';
import { colors } from '@peachjar/components';
import { injectGlobal } from 'emotion';

const { platinum, prussian } = colors;

const PortalAppTheme = createMuiTheme({
  palette: {
    type: 'light',
  },
  typography: {
    fontSize: 13,
    fontFamily: "'Proxima Nova', Helvetica, sans-serif",
    display1: {
      fontSize: 34,
      fontWeight: 600,
      color: prussian,
      lineHeight: 1.18,
      paddingBottom: 16,
    },
    headline: {
      paddingBottom: 32,
    },
  },
  props: {
    MuiPaper: {
      elevation: 0,
      square: true,
    },
  },
  overrides: {
    ListItemText: {
      root: {
        fontSize: 13,
      },
    },
    MuiGrid: {
      item: {
        marginTop: 16, // Mui bug? can spend more time to investigate later
        marginBottom: 16, // Mui bug? can spend more time to investigate later
      },
    },
  },
});

injectGlobal`
html {
  font-size: 16px;
}
body {
  background-color: ${platinum}
}
svg.illustration {
  display: block
}
`;

export default PortalAppTheme;



// WEBPACK FOOTER //
// ./src/_app/app.base.css.theme.js